import apiClient from './apiClient';

const BASE = '/turnos-anses';

// La ida vigente de un trámite. El backend responde 204 cuando todavía no hay ninguna,
// así que devolvemos null en lugar de romper la tarjeta.
export async function obtenerTurnoAnsesPorTramite(idTramite) {
    const { data, status } = await apiClient.get(`${BASE}/tramite/${idTramite}`);
    return status === 204 ? null : data;
}

export async function listarHistorialPorTramite(idTramite) {
    const { data } = await apiClient.get(`${BASE}/tramite/${idTramite}/historial`);
    return Array.isArray(data) ? data : [];
}

export async function obtenerTurnoAnses(idTurnoAnses) {
    const { data } = await apiClient.get(`${BASE}/${idTurnoAnses}`);
    return data;
}

export async function listarTurnosAnsesPorFecha(fecha) {
    const { data } = await apiClient.get(BASE, { params: fecha ? { fecha } : {} });
    return Array.isArray(data) ? data : [];
}

// Agenda del módulo: incluye los turnos con poder de un abogado del estudio, que no pasan
// por el turnero.
export async function listarAgendaTurnosAnses({ desde, hasta, estado } = {}) {
    const { data } = await apiClient.get(`${BASE}/agenda`, { params: { desde, hasta, estado } });
    return Array.isArray(data) ? data : [];
}

// Seguimiento: las idas con alguna presentación en ese resultado (el uso real es CONDICIONAL).
export async function listarTurnosAnsesPorResultado(resultado) {
    const { data } = await apiClient.get(`${BASE}/por-resultado/${resultado}`);
    return Array.isArray(data) ? data : [];
}

export async function crearTurnoAnses(turno) {
    const { data } = await apiClient.post(BASE, turno);
    return data;
}

export async function editarTurnoAnses(idTurnoAnses, datos) {
    const { data } = await apiClient.put(`${BASE}/${idTurnoAnses}`, datos);
    return data;
}

// presentacion = { idTramite } o { idTipoTramite } — la carpeta es opcional.
export async function agregarPresentacion(idTurnoAnses, presentacion) {
    const { data } = await apiClient.post(`${BASE}/${idTurnoAnses}/presentaciones`, presentacion);
    return data;
}

export async function quitarPresentacion(idTurnoAnses, idPresentacion) {
    const { data } = await apiClient.delete(`${BASE}/${idTurnoAnses}/presentaciones/${idPresentacion}`);
    return data;
}

// Engancha la carpeta a una presentación cargada antes de que el trámite existiera.
export async function vincularTramiteAPresentacion(idTurnoAnses, idPresentacion, idTramite) {
    const { data } = await apiClient.patch(
        `${BASE}/${idTurnoAnses}/presentaciones/${idPresentacion}/tramite/${idTramite}`
    );
    return data;
}

// Cómo salió la presentación: INGRESADO (pide expediente), RECHAZADO (pide motivo),
// CONDICIONAL (ingreso por insistencia, sin expediente todavía), NO_PRESENTADO o PENDIENTE.
export async function registrarResultadoPresentacion(idTurnoAnses, idPresentacion, resultado) {
    const { data } = await apiClient.patch(
        `${BASE}/${idTurnoAnses}/presentaciones/${idPresentacion}/resultado`, resultado
    );
    return data;
}

export async function cancelarTurnoAnses(idTurnoAnses, motivo) {
    const { data } = await apiClient.patch(`${BASE}/${idTurnoAnses}/cancelar`, { motivo });
    return data;
}

// Cierra un turno de vista con la observación de qué se vio. Una vista no tiene resultado:
// no se presentó nada, así que lo único que queda registrado es el texto.
export async function cerrarVistaTurnoAnses(idTurnoAnses, observacion) {
    const { data } = await apiClient.patch(`${BASE}/${idTurnoAnses}/cerrar-vista`, { observacion });
    return data;
}

// Borra definitivamente un turno cancelado. El backend solo lo permite sobre cancelados.
export async function eliminarTurnoAnses(idTurnoAnses) {
    await apiClient.delete(`${BASE}/${idTurnoAnses}`);
}

export async function resolverFirmaTurnoAnses(idTurnoAnses, firmaResuelta, observacion) {
    const { data } = await apiClient.patch(`${BASE}/${idTurnoAnses}/firma`, { firmaResuelta, observacion });
    return data;
}
// Deja registrado si ya se le avisó al cliente que tiene turno. citado=false con observación
// es el intento que no llegó a la persona: queda la nota, sin darlo por citado.
export async function registrarCitacionTurnoAnses(idTurnoAnses, citado, observacion) {
    const { data } = await apiClient.patch(`${BASE}/${idTurnoAnses}/citacion`, { citado, observacion });
    return data;
}
